import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TooltipPosition } from '@angular/material/tooltip';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ContactsComponent } from './contacts/contacts.component';
import { PersonalDeContactoService } from '../../services/personal-de-contacto.service';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import { CompanyContact } from '../models/Contacts/CompanyContact';
import Utils from 'app/Utils';

@Component({
    selector: 'app-personal-de-contacto',
    templateUrl: './personal-de-contacto.component.html',
    styleUrls: ['./personal-de-contacto.component.scss'],
    standalone: false
})
export class PersonalDeContactoComponent implements OnInit {
  @Input() companyId : any
  displayedColumns = ['Empresa', 'Nombre', 'Cargo', 'Email', 'Telefono', 'Movil', 'Comentarios', 'Options'];
  positionOptions: TooltipPosition[] = ['left'];

  public dataSource: CompanyContact[] = null
  public contact: CompanyContact
  public permissionList = new Array<string>();
  selectedCompanyId;

  constructor
    (
      private dialog: MatDialog,
      private sharedService: SharedService,
      private _personalDeContactoService: PersonalDeContactoService,
      private _companySideBarTreeViewService: CompanySideBarTreeViewService
    ) {  
  }

  
  ngOnInit(): void {
    this.selectedCompanyId = this.companyId   

    this.contact = new CompanyContact()
    //check if the company is selected before sending the API call
    if (this.selectedCompanyId != null) {
      this.getAllContactsByCompanyId(this.selectedCompanyId);
    }

    const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    if (currentUser) {
      this.permissionList = this.sharedService.getCurrentUserPermissions();
    }   
  }


  public addOrEdit(selectedRow: CompanyContact): void {    
    if (selectedRow !== null) {
      this.contact = selectedRow
    } else {
      this.contact.id = 0
      this.contact.empresaId = Number(this.selectedCompanyId)
    }
    const dialogRef = this.dialog.open(ContactsComponent, {
      data: this.contact
    });
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this.getAllContactsByCompanyId(this.selectedCompanyId);
      }
    });
  }

  public deleteContact(contact: any) {
    const dialogData = new ConfirmDialogModel('¿Eliminar contacto?', '');
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this._personalDeContactoService.DeleteContact(contact.id).subscribe(result => {
          if (result) {
            this.getAllContactsByCompanyId(this.selectedCompanyId);
            this.sharedService.ShowSnackBar('Borrado exitosamente', 'Okay', 2000);
          } else {
            this.sharedService.ShowSnackBar('Error al eliminar', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this.sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
        });
      }
    }
    )
  }

  private getAllContactsByCompanyId(companyId: any) {
    this._personalDeContactoService.GetAllContactListById(companyId)
      .subscribe(res => {
        this.dataSource = res.result;
      });
  }
}


